import {pushEdapEvent} from '../../utils/edap';

export const ACTION_LOCATION = 'property-types-module';

export function pushHandlerClickData(propertyType, index) {
    const eventOptions = {
        actionlocation: ACTION_LOCATION,
        eventrefinements: `${propertyType},position:${index}`
    };

    return () => pushEdapEvent('search.link.click', eventOptions);
}

export const pushHandleNextData = () => {
    const edapData = {
        actionlocation: ACTION_LOCATION
    };

    pushEdapEvent('nav.next.click', edapData);
};

export const pushHandlePrevData = () => {
    const edapData = {
        actionlocation: ACTION_LOCATION
    };

    pushEdapEvent('nav.previous.click', edapData);
};
